import React from "react";
import { Pending, ReadyForReview, Rejected, Verified } from "../../../components/components/StatusIndicators";

const StatusIndicator = ({indicator}) => {
  return (
    <>
      {indicator?.remarks !== null &&
        indicator?.isFilledStatus === false &&
        indicator?.formStatusByHR === false && (
          <span style={{ color: "red" }}>{indicator?.remarks}</span>
        )}
      {(indicator?.isFilledStatus === false &&
        indicator?.formStatusByHR === null) ||
      !indicator ? (
        <Pending />
      ) : (
        <>
          {(indicator?.formStatusByHR === null ||
            indicator?.formStatusByHR === false) &&
          indicator?.isFilledStatus === true ? (
            <ReadyForReview />
          ) : (
            <>{indicator?.formStatusByHR ? <Verified /> : <Rejected />}</>
          )}
        </>
      )}
    </>
  );
};

export default StatusIndicator;
